<div class="da-header-section">
    <h1>Checkout</h1>
</div>

<div class="da-main-layout">
    <!-- Left Column -->
    <div class="main-column">
        <div class="cart-label"
            style="font-size: 11px; font-weight: 800; color: #333; letter-spacing: 1px; margin-bottom: 10px;">YOUR CART
        </div>

        <div class="da-card college-card add-college-card">
            <div class="left-side">
                <div class="icon">
                    <img src="assets/icons/uni_icon.png" alt="Counselling session" onerror="this.style.display='none'">
                </div>
                <div class="details">
                    <h3 class="name">30 mins premium counselling session</h3>
                </div>
            </div>
            <div class="right-side">
                <div class="price">₹5,000</div>
            </div>
        </div>

        <div class="da-card college-card add-college-card">
            <div class="left-side">
                <div class="icon">
                    <img src="assets/icons/uni_icon.png" alt="DA Fee" onerror="this.style.display='none'">
                </div>
                <div class="details">
                    <h3 class="name">DA Fee</h3>
                </div>
            </div>
            <div class="right-side">
                <div class="price">₹5,000</div>
            </div>
        </div>

        <!-- Bottom Banner -->
        <div class="cta-banner">
            <div class="left-content">
                <div class="img-wrapper">
                    <img src="assets/icons/review_icon.png" alt="Illustration" onerror="this.style.display='none'">
                </div>
                <div class="text">
                    <h3>Not sure about your shortlist?</h3>
                    <p>Get a free 1:1 profile review before you pay. Priya has guided 1,200+ students into top-30
                        programs, she'll tell you exactly where you stand.</p>
                </div>
            </div>
            <button class="btn-yellow" (click)="showClarityCallDialog = true">Book My Clarity Call</button>
        </div>
    </div>

    <!-- Right Column (Order Summary) -->
    <div class="right-column">
        <div class="sticky-panel">
            <div class="da-card order-summary">
                <div class="title">Order Summary</div>
                <div class="summary-subtitle">Processing fee secures your seat in the queue</div>

                <div class="item-row">
                    <div class="label">Expert Session + 5 College Applications</div>
                    <div class="value">₹{{ baseAmount }}</div>
                </div>

                <div class="divider"></div>

                <div class="item-row">
                    <div class="label">GST (18%)</div>
                    <div class="value">₹{{ gstAmount }}</div>
                </div>

                <div class="discount-row">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <i class="pi pi-gift" style="color: #f57f17;"></i> Profile review included
                    </div>
                    <div class="strike">₹3,000</div>
                </div>

                <div class="divider"></div>

                <div class="total-row">
                    <div class="label">Total payable <span class="sub">incl. all taxes & fees</span></div>
                    <div class="value">₹{{ totalAmount }}</div>
                </div>

                <button pButton class="payment-btn" (click)="onContinue()"
                    [disabled]="loading || paymentInProgress"
                    [loading]="paymentInProgress" icon="pi pi-arrow-right" iconPos="right" label="Continue to Payment"
                    style="width: 100%; border-radius: 8px; padding: 12px; font-weight: 600; display: flex; justify-content: center; align-items: center; gap: 8px; background-color: #000086; color: white; border: none; cursor: pointer;">
                </button>

            </div>
        </div>
    </div>
</div>

<!-- Clarity Call Dialog — shared reusable component -->
<app-clarity-call-popup
  [(visible)]="showClarityCallDialog"
  [contactPurpose]="ContactPurpose.ExpertCheckoutContactUs"
 headline="Confused about your application process?<br>Let's sort it."
  bodyText="You don't have to figure out your application alone. Whether it's choosing universities, picking an apply option, or getting through the form — drop it here and we'll help you move forward."
  inputPlaceholder="Stuck on a step? Tell us here"
  ctaLabel="Get help">
</app-clarity-call-popup>